<template>
	<div>
		<Hrader :idShwo="4" @skipCompents="landingClcik"></Hrader>
		<div style="height: 70px"></div>
		<div>
			<img src="../../assets/cooperation_slices/Maskgroup.png" style="width: 100%; height: auto" />
		</div>

		<div class="rectangle" style="margin-top: -10px">
			<div class="rectangle-with">
				<div class="flex-rectange">
					<div>
						<img src="../../assets/recycling_slices/Vector@2x.png" style="width: 12px; height: 13px" />
					</div>
					<div class="current-recy">当前位置 : 商务合作</div>
				</div>
			</div>
		</div>
	</div>

	<div class="cooperation">
		<div class="assets-cooptaioc">
			<div class="flex-assets">
				<img src="../../assets/assets-sea/Group 1834@2x.png" style="width: 940px; height: 200px" />
			</div>
			<div class="row-flex-assets">
				<div class="row-flex-group" @click="dialogVisible = true">
					<img src="../../assets/assets-sea/Group 1835@2x.png" style="width: 564px; height: 395px" />
					<div class="title-group">立即接入</div>
				</div>
				<div class="row-flex-group" @click="dialogVisible = true">
					<img src="../../assets/assets-sea/Group 1836@2x.png" style="width: 564px; height: 395px" />
					<div class="title-group">立即咨询</div>
				</div>
			</div>
		</div>

		<div class="cooper-current">
			<img src="../../assets/assets-sea/Group 1837@2x.png" style="width: 1250px; height: 685px" />
		</div>
	</div>

	<el-dialog v-model="dialogVisible" :show-close="false" width="627">
		<div class="flex">
			<div>
				<img src="@/assets/Group 1876@2x.png" style="width: 222px; height: 260px" />
			</div>
			<div style="margin-left: 25px">
				<div class="flex">
					<div class="flex-title">客服热线</div>
					<img src="@/assets/assets-push/Vector@2x (24).png" style="margin-top: -7px; width: 23px; height: 23px" />
				</div>
				<div class="electricity">400-696-5550</div>
				<div class="title-flex">客服时间：周一至周日 09:00-23:00</div>
				<div class="title-flex">联系邮箱：jingkashou@163.com</div>
				<div class="title-flex">联系地址：辽宁省大连市中山区桃仙街</div>
				<div class="title-flex">商务电活：19118810421</div>
				
				<div class="close" @click="dialogVisible = false">关闭</div>
			</div>
		</div>
		<template #footer>
			<div class="service-hotline">
				<img src="@/assets/assets-push/image 72@2x.png" class="service-padd" />
			</div>
		</template>
	</el-dialog>

	<Tabr></Tabr>
	<div>
		<Customer></Customer>
	</div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import Tabr from '@/components/tabr.vue';
import Customer from '@/components/customer.vue';
import Landing from '@/components/landing.vue';
import Hrader from '@/components/header.vue';
import { cardList, categoryList } from '@/utils/api.js';
let router = useRouter();
const dialogVisible = ref(false);
let showDetails = ref(false);
let idsIndex = ref(0);
let indexNumber = ref(1);
let idsIndex1 = ref(0);
let indexNumber1 = ref(1);
let idsIndex2 = ref(0);
let indexNumber2 = ref(1);
let idsIndex3 = ref(0);
let indexNumber3 = ref(1);
let ids = ref(7);
let listData = ref([]);
let listDataCard = ref([]);
let dataListSkip = ref([]);
let dataSkipList = ref([]);
let marListRef = ref([]);
const skipClick = (item) => {
	console.log(item);
	router.push({ path: item });
};
const info = async (index, item) => {
	let res = await cardList({
		categoryId: item.id
	});
	if (index == 0) {
		listData.value = res.data;
	} else if (index == 1) {
		listDataCard.value = res.data;
	} else if (index == 2) {
		dataListSkip.value = res.data;
	} else {
		dataSkipList.value = res.data;
	}
};
const infoList = async (item) => {
	let res = await categoryList();
	marListRef.value = res.data;
	marListRef.value.forEach((item, index) => {
		info(index, item);
	});
};
const reduction = () => {
	if (indexNumber.value == 1) return false;
	indexNumber.value--;
	idsIndex.value--;
};
const plus = () => {
	if (indexNumber.value * 6 < listDataCard.value.length) {
		indexNumber.value++;
		idsIndex.value++;
	}
};

const reduction2 = () => {
	if (indexNumber2.value == 1) return false;
	indexNumber2.value--;
	idsIndex2.value--;
};
const plus2 = () => {
	if (indexNumber2.value * 6 < listData.value.length) {
		indexNumber2.value++;
		idsIndex2.value++;
	}
};

const reduction1 = () => {
	if (indexNumber1.value == 1) return false;
	indexNumber1.value--;
	idsIndex1.value--;
};

const plus1 = () => {
	if (indexNumber1.value * 6 < dataSkipList.value.length) {
		indexNumber1.value++;
		idsIndex1.value++;
	}
};

const reduction3 = () => {
	if (indexNumber3.value == 1) return false;
	indexNumber3.value--;
	idsIndex3.value--;
};

const plus3 = () => {
	if (indexNumber3.value * 6 < dataListSkip.value.length) {
		indexNumber3.value++;
		idsIndex3.value++;
	}
};

onMounted(() => {
	infoList();
});
</script>

<style lang="scss" scoped>
.flex {
	display: flex;
}
.align {
	align-items: center;
}

.justify {
	justify-content: center;
}

.electricity {
	font-family: PingFang SC, PingFang SC;
	font-weight: 600;
	font-size: 22px;
	color: #ff0000;
	font-style: normal;
	text-transform: none;
	margin-top: 10px;
}

.flex-title {
	font-family: PingFang SC, PingFang SC;
	font-weight: 600;
	font-size: 16px;
	color: #333333;
	letter-spacing: 4px;
	font-style: normal;
	text-transform: none;
}

.title-flex {
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 14px;
	color: #222222;
	font-style: normal;
	text-transform: none;
	margin-top: 14px;
}

.close {
	width: 135px;
	height: 42px;
	background: #ff3333;
	border-radius: 4px 4px 4px 4px;
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 16px;
	color: #ffffff;
	line-height: 42px;
	text-align: center;
	font-style: normal;
	text-transform: none;
	margin-top: 20px;
}

.close:hover {
	cursor: pointer;
}

.head-guidance {
	width: 100%;
	height: 70px;
	background: #ffffff;
	border-radius: 0px 0px 0px 0px;
	position: fixed;
	top: 0;
	z-index: 111;
	.head-guidance-flex {
		width: 100%;
		display: flex;
		justify-content: space-between;
		.image {
			width: 106px;
			height: 40px;
			margin-top: 15px;
			margin-left: 160px;
		}
	}
	.head-right {
		display: flex;
		margin-right: 104px;

		.head-right-flex {
			display: flex;
			align-items: center;
			margin-top: 12px;
			margin-left: 36px;

			.home-right {
				font-family: PingFang SC, PingFang SC;
				font-weight: 400;
				font-size: 16px;
				color: #333333;
				text-align: left;
				font-style: normal;
				text-transform: none;
				margin-left: 6px;
			}
		}

		.head-right-flex:hover {
			cursor: pointer;
		}

		.head-right-flex1:hover {
			cursor: pointer;
		}

		.head-right-flex1 {
			display: flex;
			align-items: center;
			padding: 11px 16px;
			background: #ff3333;
			border-radius: 74px 74px 74px 74px;
			margin-top: 13px;

			.home-right {
				font-family: PingFang SC, PingFang SC;
				font-weight: 400;
				font-size: 16px;
				color: #fff;
				text-align: left;
				font-style: normal;
				text-transform: none;
				margin-left: 6px;
			}
		}
		.frame-flex {
			height: 18px;
			border-right: 1px solid #dddddd;
			margin-top: 26px;
			margin-left: 22px;
			padding-right: 44px;
		}
	}
}
.cooperation {
	width: 1280px;
	margin: auto;
}

.assets-cooptaioc {
	padding: 45px;
	padding-top: 75px;
	background-color: #fff;
	margin-top: 21px;
	border-radius: 5px;
}

.flex-assets {
	margin-left: 155px;
}

.cooper-current {
	padding: 16px;
	padding-bottom: 40px;
	background: #fff;
	margin-top: 20px;
	border-radius: 5px;
}

.row-flex-assets {
	display: flex;
	margin-left: -60px;
	margin-top: 77px;
}
.row-flex-group {
	margin-left: 60px;
}
.title-group {
	width: 162px;
	height: 42px;
	background: #ff2f17;
	border-radius: 64px 64px 64px 64px;
	text-align: center;
	line-height: 42px;
	font-family: PingFang SC, PingFang SC;
	font-weight: 400;
	font-size: 16px;
	color: #ffffff;
	letter-spacing: 2px;
	font-style: normal;
	text-transform: none;
	margin: auto;
	margin-top: 50px;
}

.title-group:hover {
	cursor: pointer;
}

.service-hotline {
	position: relative;
	height: 10px;
}
.service-padd {
	position: absolute;
	width: 139px;
	height: 139px;
	bottom: -40px;
	right: 0;
}
</style>
